import type { ContactAction } from "features/contacts/data/types";

import type { ContactStatus } from "./PersonContact.types";

export const getStatusByAction = (
  currentStatus: ContactStatus,
  action: ContactAction,
): ContactStatus => {
  if (action === "add") {
    return currentStatus === "their_request" ? "mutual" : "my_request";
  }
  if (action === "remove") {
    return "none";
  }

  return "none";
};
